module.exports = __webpack_public_path__ + "static/media/Dan_Green_ID.d8ec1730.jpg";